import instantsearch from 'instantsearch.js'
import algoliasearch from 'algoliasearch/lite'

import customHits from '../utils/algolia/customHits'
import { configure, pagination, refinementList, searchBox } from 'instantsearch.js/es/widgets'

export default {
  name: 'algolia-list',

  ui: {
    results: '[js-algolia-list-results]',
    pagination: '[js-algolia-list-pagination]',
    filters: '[js-algolia-list-filters]',
    toggleFilters: '[js-algolia-list-toggle-filters]',
    searchBox: '[js-algolia-list-searchbox]',
  },

  componentDidMount () {
    const indexName = `${config.algolia.env}_pages`

    this.searchClient = algoliasearch(
      config.algolia.applicationID,
      config.algolia.apiKey,
    )

    this.search = instantsearch({
      indexName: `${indexName}`,
      searchClient: this.searchClient,
    })

    this.search.addWidgets([
      // global
      configure({
        hitsPerPage: 6,
        filters: `locale:${config.locale} AND visible:true AND ${this.props.type === 'publication' ? 'type:white-book OR type:article OR type:expert-opinion OR type:podcast' : `type:${this.props.type}`}`,
      }),
      pagination({
        container: this.ui.pagination,
        showFirst: false,
        showLast: false,
        scrollTo: this.ui.results,
        templates: {
          previous: '<svg width="32" height="32" viewBox="0 0 32 32"><g transform="matrix(-1 0 0 1 32 0)" fill="none" fill-rule="evenodd"><path stroke-width="1.5" stroke-linejoin="round" d="m18 12-4 4 4 4"/></g></svg>',
          next: '<svg width="32" height="32" viewBox="0 0 32 32"><g transform="matrix(-1 0 0 1 32 0)" fill="none" fill-rule="evenodd"><path stroke-width="1.5" stroke-linejoin="round" d="m18 12-4 4 4 4"/></g></svg>',
        },
      }),
      // results
      customHits({
        container: this.ui.results,
        type: this.props.type,
      }),
    ])

    if (this.props.type === 'publication') {
      this.search.addWidgets([
        refinementList({
          container: this.ui.filters,
          attribute: 'type',
          sortBy: ['name'],
          templates: {
            item (item, { html }) {
              const { url, label, isRefined } = item

              return html`
                <a href="${url}" class="filters__link ${isRefined ? 'is-active' : ''}">
                  <span>${config.trads[`publication.tag.${label}`]}</span>
                </a>
              `
            },
          },
        }),
        searchBox({
          container: this.ui.searchBox,
          showReset: false,
          placeholder: config.trads['search.front.placeholder'],
          templates: {
            submit ({ cssClasses }, { html }) {
              return html`<svg width="16" height="16"><use href="#icon-search" xlink:href="#icon-search"></use></svg>`
            },
          },
        }),
      ])
    }

    this.search.start()

    // manage filters dropdown
    if (this.ui.toggleFilters) {
      this.ui.toggleFilters.addEventListener('click', () => {
        this.ui.filters.classList.toggle('is-active')
        this.ui.toggleFilters.classList.toggle('is-active')
      })

      document.body.addEventListener('click', (e) => {
        if (!e.target.closest('.filters') && !e.target.classList.contains('.filters')) {
          this.ui.filters.classList.remove('is-active')
          this.ui.toggleFilters.classList.remove('is-active')
        }
      })
    }
  },
}
